import { t } from "@lingui/core/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { HStack, Text } from "@whoosh/design-system/src/components/primitive";

import { StoreProductPackageItem } from "./StoreProductPackageItem";
import { StoreProductList_packageConnection$key } from "./__generated__/StoreProductList_packageConnection.graphql";
import { StoreProductList_session$key } from "./__generated__/StoreProductList_session.graphql";

type Props = {
  sessionRef?: StoreProductList_session$key | null;
  packageConnectionRef?: StoreProductList_packageConnection$key | null;
  onPackageAuthComplete?: () => void;
};
export const StoreProductList = ({
  sessionRef,
  packageConnectionRef,
  onPackageAuthComplete,
}: Props) => {
  const packageConnection = useFragment(
    StoreProductListFragmentString,
    packageConnectionRef
  );
  const session = useFragment(
    StoreProductListSessionFragmentString,
    sessionRef
  );

  const packages =
    packageConnection?.edges?.flatMap((edge) =>
      edge?.node ? [edge.node] : []
    ) ?? [];

  const hasPackages = packages.length > 0;

  return hasPackages ? (
    <HStack
      flexDirection={{ base: "column", lg: "row" }}
      flexWrap="wrap"
      gap={{ base: 4, md: 8 }}
      pt={{ base: 4, md: 8 }}
      pb={8}
    >
      {packages.map((pkg) => (
        <StoreProductPackageItem
          key={pkg.id}
          packageRef={pkg}
          sessionRef={session}
          onPackageAuthComplete={onPackageAuthComplete}
        />
      ))}
    </HStack>
  ) : (
    <HStack>
      <Text>{t`Not currently available`}</Text>
    </HStack>
  );
};

const StoreProductListFragmentString = graphql`
  fragment StoreProductList_packageConnection on PackageConnection {
    edges {
      node {
        id
        ...StoreProductPackageItem_package
      }
    }
  }
`;

const StoreProductListSessionFragmentString = graphql`
  fragment StoreProductList_session on Session {
    ...StoreProductPackageItem_session
  }
`;
